import { FormProvider, useForm } from "react-hook-form";
// import Switch from "../../../components/common/Switch";
import DiscardSaveButtons from "../../../components/tv-app/discard-save-buttons";
import { IAppsSettings, ICategoryComponentProps } from "../../../utils/types";
import SortableList from "../../../components/common/SortableList";

interface IFormData {
  apps: Array<IAppsSettings>;
}

const APPS = [
  { id: 1, image: "clear-cred.png" },
  { id: 2, image: "netflix.png" },
  { id: 3, image: "apple-tv.png" },
  { id: 4, image: "hulu.png" },
  { id: 5, image: "amazon-prime.png" },
  { id: 6, image: "youtube-premium.png" },
  { id: 7, image: "tubi.png" },
  { id: 8, image: "max.png" },
  { id: 9, image: "disney-plus.png" },
  { id: 10, image: "youtube-tv.png" },
  { id: 11, image: "espn.png" },
  { id: 12, image: "fubo.png" },
  { id: 12, image: "peacock-tv.png" },
  { id: 13, image: "sling-tv.png" },
  { id: 14, image: "prime-video.png" },
  { id: 15, image: "paramount.png" },
  { id: 16, image: "haystack-news.png" },
  { id: 17, image: "pluto-tv.png" },
  { id: 18, image: "plex.png" },
  { id: 19, image: "amazon-freevee.png" },
  { id: 20, image: "abc-news.png" },
];

const MyApps = ({ data, onSave }: ICategoryComponentProps) => {
  const getInitialFormData = () => ({
    apps: data?.apps,
  });
  const methods = useForm<IFormData>({ defaultValues: getInitialFormData() });

  const { handleSubmit, watch } = methods;
  const { apps } = watch();

  return (
    <FormProvider {...methods}>
      <div>
        {/* <div className="">
          <Switch label="My Apps (Hide/Show)" name="showApps" />
        </div> */}
        {apps?.map((app, index: number) => (
          <div key={index} className="my-2">
            <h3 className="text-[22px] font-normal text-[#111827]">
              {app?.category}
            </h3>
            <p className="text-xs leading-[39px] font-light text-[#111827]">
              Note : Drag and adjust the numbering to change the order
            </p>
            <div className="flex items-center flex-wrap gap-x-[14px] gap-y-[17px]">
              <SortableList
                direction="horizontal"
                sortableArray={app?.list}
                onSort={(sortedList: any[]) => {
                  const newApps = [...apps];
                  newApps[index] = {
                    ...newApps[index],
                    list: sortedList,
                  };
                  methods.setValue("apps", newApps);
                }}
                className="flex-wrap"
                itemClassName="w-[100px] h-[100px] flex justify-center items-center text-center  text-[#F41095] rounded cursor-pointer select-none gap-x-[14px] gap-y-[17px]"
              >
                {app?.list.map((items: any, index: number) => {
                  const formattedItemName = String(items.name)
                    .toLowerCase()
                    .trim()
                    .replace(/\s+/g, "-");
                  const imageSrc = APPS.find((ele) => {
                    const formattedEleImage = ele.image
                      .replace(/[\/\.]/g, "")
                      .toLowerCase()
                      .trim();
                    const regex = new RegExp(formattedItemName, "i");
                    return regex.test(formattedEleImage);
                  })?.image;

                  return (
                    <>
                      <img
                        key={index}
                        src={`/images/free-apps/${imageSrc || ""}`}
                      />
                    </>
                  );
                })}
              </SortableList>
            </div>
          </div>
        ))}
        {/* </div> */}

        <DiscardSaveButtons
          onDiscard={() => {}}
          onSave={handleSubmit((submitData: IFormData) => {
            const formData = new FormData();
            const newArr = submitData?.apps?.map((item) => item);
            const updatedData = {
              ...data,
              apps: newArr,
            };
            formData.append("categoryName", updatedData.categoryName);
            formData.append("data", JSON.stringify(updatedData));
            onSave(formData);
          })}
          loading={false}
          className="mt-10"
        />
      </div>
    </FormProvider>
  );
};

export default MyApps;
